import React from 'react';

import { Paragraph } from './Introduction.styled';

interface Props {
    children: string;
}

const Introduction: React.FC<Props> = props => {
    const { children } = props;

    return <Paragraph>{children}</Paragraph>;
};

export default Introduction;
